function InfoGrid({ columns = 3, items = [] }) {
  const colClass = {
    2: "grid-cols-2",
    3: "grid-cols-2 lg:grid-cols-3",
  };

  const statusColors = {
    active: "bg-[#00c851] text-white",
    cancelled: "bg-red-500 text-white",
    paused: "bg-yellow-400 text-white",
    trialing: "bg-blue-500 text-white",
  };

  return (
    <div className={`grid ${colClass[columns] || "grid-cols-2"} gap-6`}>
      {items.length > 0 && items.map((item, i) => (
        <div key={i}>
          <p className="text-sm font-medium text-gray-500 mb-1">{item.label}</p>
          {item.type === "badge" && (
            <span
              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium uppercase tracking-wide ${
                statusColors[String(item.value ?? "").toLowerCase()] || "bg-gray-200 text-gray-700"
              }`}
            >
              {item.value}
            </span>
          )}
          {item.type === "code" && (
            <code className="text-sm text-gray-700 bg-white px-2 py-1 rounded border border-gray-200">
              {item.value}
            </code>
          )}
          {item.type === "icon-text" && (
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-[#27815C]"
                aria-hidden="true"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
              <span className="text-sm text-gray-600">{item.value}</span>
            </div>
          )}
          {(!item.type || item.type === "text") && (
            <p className="text-sm text-gray-900">{item.value}</p>
          )}
        </div>
      ))}
    </div>
  );
}

export default InfoGrid;